import { css } from "@emotion/css";
import styled from "@emotion/styled";

const GUTTER = 24;

export const Container = styled.div`
    margin-right: ${-GUTTER / 2}px;
    margin-left: ${-GUTTER / 2}px;
`;

export const row = css`
    &:first-child {
        margin-bottom: ${GUTTER}px;
    }
`;

export const flexChild = css`
    flex-basis: 50%;
    padding-right: ${GUTTER / 2}px;
    padding-left: ${GUTTER / 2}px;
`;

export const flexChildOneThird = css`
    flex-basis: ${100 / 3}%;
`;

export const flexChildGrow = css`
    flex-grow: 1;
`;

export const twoLineHeader = css`
    header {
        min-height: 52px;
    }
`;
